import styles from './PasswordRequirement.module.scss';
import cx from 'classnames';
import { Icon, Text } from 'components';

type Props = {
  isChecked: boolean;
  text: string;
};

export const PasswordRequirement = ({ text, isChecked = false }: Props) => (
  <div className={cx(styles.container, { [styles.checked]: isChecked })}>
    <Icon name="SmallTick" />
    <Text type="caption">{text}</Text>
  </div>
);
